export type GCounter = Record<string, { counter: number }>;

export function mergeGCounters(local: GCounter | undefined, remote: GCounter | undefined): GCounter {
  const merged: GCounter = { ...(local ?? {}) };
  for (const [deviceId, remoteState] of Object.entries(remote ?? {})) {
    const localCounter = merged[deviceId]?.counter ?? 0;
    merged[deviceId] = {
      counter: Math.max(localCounter, remoteState.counter),
    };
  }
  return merged;
}

export function incrementGCounter(clock: GCounter, deviceId: string): number {
  const next = (clock[deviceId]?.counter ?? 0) + 1;
  clock[deviceId] = { counter: next };
  return next;
}

export function readGCounter(clock: GCounter, deviceId: string): number {
  return clock[deviceId]?.counter ?? 0;
}
